import { API_BASE_URL } from '../config';
import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Button,
  Box,
  Tabs,
  Tab,
  Alert,
  CircularProgress
} from '@mui/material';
import axios from 'axios';

const RecuperarPassword = () => {
  const [tabValue, setTabValue] = useState(0);
  const [dni, setDni] = useState('');
  const [preguntas, setPreguntas] = useState([]);
  const [respuestas, setRespuestas] = useState({});
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  const handleBuscarPreguntas = async () => {
    setError('');
    setMensaje('');
    if (!dni) {
      setError('Ingresa tu DNI');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/api/preguntas-secretas/aleatorias/${dni}`);
      setPreguntas(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al buscar preguntas');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitPreguntas = async () => {
    setError('');
    setMensaje('');
    try {
      setLoading(true);
      await axios.post(`${API_BASE_URL}/api/preguntas-secretas/verificar`, {
        dni,
        respuestas,
        nuevaPassword
      });
      setMensaje('✅ Contraseña actualizada exitosamente');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || '❌ Respuestas incorrectas');
    } finally {
      setLoading(false);
    }
  };

  const handleRecuperarPorEmail = async () => {
    setError('');
    setMensaje('');
    if (!dni) {
      setError('Ingresa tu DNI');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE_URL}/api/auth/recuperar-email`, { dni });

      const emailParcial = res.data.email_enviado_a;
      setMensaje(`✅ ${res.data.message}\n📧 Revisa tu email: ${emailParcial}`);
    } catch (err) {
      if (err.response?.data?.code === 'EMAIL_TEMPORAL') {
        setError('⚠️ Debes actualizar tu email personal. Por favor inicia sesión para configurarlo.');
      } else {
        setError(err.response?.data?.error || 'Error al enviar email');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 5, p: 3 }}>
      <Typography variant="h4" gutterBottom align="center">
        Recuperar Contraseña
      </Typography>

      <Tabs
        value={tabValue}
        onChange={(e, newValue) => setTabValue(newValue)}
        centered
        sx={{ mb: 3 }}
      >
        <Tab label="Por Email" />
        <Tab label="Por Preguntas Secretas" />
      </Tabs>

      {mensaje && (
        <Alert severity="success" sx={{ mb: 2, whiteSpace: 'pre-line' }}>
          {mensaje}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {tabValue === 0 && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Ingresa tu DNI y te enviaremos una contraseña temporal a tu email personal.
          </Typography>
          <TextField
            label="DNI"
            fullWidth
            margin="normal"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            disabled={loading}
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleRecuperarPorEmail}
            disabled={loading || !dni}
          >
            {loading ? <CircularProgress size={24} /> : 'Enviar Contraseña Temporal'}
          </Button>
        </Box>
      )}

      {tabValue === 1 && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Responde tus preguntas secretas para restablecer tu contraseña.
          </Typography>
          <TextField
            label="DNI"
            fullWidth
            margin="normal"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
            disabled={loading}
          />
          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 1 }}
            onClick={handleBuscarPreguntas}
            disabled={loading || !dni}
          >
            {loading ? <CircularProgress size={24} /> : 'Buscar Preguntas'}
          </Button>

          {preguntas.map((p) => (
            <TextField
              key={p.id}
              label={p.texto}
              fullWidth
              margin="normal"
              onChange={(e) => setRespuestas({ ...respuestas, [p.id]: e.target.value })}
              disabled={loading}
            />
          ))}

          {preguntas.length > 0 && (
            <>
              <TextField
                label="Nueva contraseña"
                type="password"
                fullWidth
                margin="normal"
                value={nuevaPassword}
                onChange={(e) => setNuevaPassword(e.target.value)}
                disabled={loading}
              />
              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
                onClick={handleSubmitPreguntas}
                disabled={loading || !nuevaPassword}
              >
                {loading ? <CircularProgress size={24} /> : 'Cambiar Contraseña'}
              </Button>
            </>
          )}
        </Box>
      )}

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button href="/login" variant="text">
          Volver al Login
        </Button>
      </Box>
    </Box>
  );
};

export default RecuperarPassword;
